import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

class Slider {
  constructor() {
    this.sliders = document.querySelectorAll('.js-slider');

    if (!this.sliders.length) {
      return;
    }

    this.init();
  }

  init() {
    this.sliders.forEach(el => {
      const autoplay = el.dataset.autoplay === 'true';
      const showNav = el.dataset.showNav === 'true';
      const showPagination = el.dataset.showPagination === 'true';
      const slidesPerView = parseInt(el.dataset.slidesPerView, 10) || 1;

      /* eslint-disable no-new */
      new Swiper(el, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView,
        spaceBetween: slidesPerView > 1 ? 30 : 0,
        loop: true,
        navigation: showNav
          ? {
              nextEl: el.querySelector('.swiper-button-next'),
              prevEl: el.querySelector('.swiper-button-prev'),
            }
          : false,
        pagination: showPagination
          ? {
              el: el.querySelector('.swiper-pagination'),
              clickable: true,
            }
          : false,
        autoplay: autoplay
          ? { delay: 5000, disableOnInteraction: false }
          : false,
      });
    });
  }
}

export default new Slider();



// WEBPACK FOOTER //
// ./src/scripts/modules/slider.js